var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotateLeft = function SvgRotateLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.5C4 1.7 3.3 1 2.5 1S1 1.7 1 2.5V10h6.5C8.3 10 9 9.3 9 8.5S8.3 7 7.5 7H5.3c.9-1.8 2.8-3 5-3 3.1 0 5.6 2.5 5.6 5.5S13.4 15 10.3 15c-1.7 0-3.1-.7-4.2-1.8-.5-.7-1.5-.7-2.1-.2-.6.6-.7 1.5-.1 2.1 1.6 1.7 3.9 2.8 6.5 2.8 4.8 0 8.7-3.8 8.7-8.5-.1-4.6-4-8.4-8.8-8.4C7.8 1 5.6 2 4 3.7V2.5z"
  })));
};
export default SvgRotateLeft;